import { defineMessages } from 'react-intl';

export default defineMessages({
  adjusterInformation: {
    id: 'src.pages.AdjusterDetailsPopUp.adjusterInformation',
    defaultMessage: 'Adjuster information',
  },
  name: {
    id: 'src.pages.AdjusterDetailsPopUp.name',
    defaultMessage: 'Name: ',
  },
  phone: {
    id: 'src.pages.AdjusterDetailsPopUp.phone',
    defaultMessage: 'Phone #: ',
  },
  email: {
    id: 'src.pages.AdjusterDetailsPopUp.email',
    defaultMessage: 'Email: ',
  },
});
